<template>
<div class="container h-100">
  <div class="row h-100">
    <div class="col-lg-5 col-md-7 col-sm-9 col-xs-12 m-auto border rounded px-3 py-3 bg-light loginbox">
      <form @submit.prevent="login()" v-if="!cambiarpass">
        <div class="row">
          <div class="col-md-12 text-center">
            <img :src="logoOscuro" class="mb-5"/>
          </div>
          <div class="col-md-12 form-group" v-if="error != ''">
            <p class="bg-danger text-light p-2 text-center rounded">{{ error }}</p>
          </div>
          <div class="col-md-12 form-group">
            <label>E-Mail</label>
            <input type="text" v-model="email" class="form-control"/>
          </div>
          <div class="col-md-12 form-group">
            <label>Contraseña</label>
            <input type="password" v-model="password" class="form-control"/>
          </div>
          <div class="col-md-12 form-group text-right">
            <input v-if="!loading" type="submit" value="Acceder" class="btn btn-primary"/>
            <button v-else class="btn btn-primary disabled" disabled>
              <font-awesome-icon icon="spinner" class="fa-spin"/> Accediendo
            </button>
          </div>
          <div class="col-md-6 text-center">
            <router-link :to="{ name: 'resetpass' }">Olvidé mi contraseña</router-link>
            
          </div>
          <div class="col-md-6 text-center">
            <router-link :to="{ name: 'registro' }">Todavía no tengo usuario</router-link>
          </div>
        </div>
      </form>

      <form @submit.prevent="changePass()" v-if="cambiarpass">
        <div class="row">
          <div class="col-md-12 text-center">
            <img :src="logoOscuro" class="mb-5"/>
          </div>
          <div class="col-md-12 form-group">
            <p class="font-weight-bold text-center">Por motivos de seguridad y para facilitar su memorización, personalice su contraseña.</p>
          </div>
          <div class="col-md-12 form-group">
            <label>Nueva contraseña</label>
            <input type="password" v-model="passwordNew" class="form-control"/>
          </div>
          <div class="col-md-12 form-group">
            <label>Repita la nueva contraseña</label>
            <input type="password" v-model="passwordNew2" class="form-control"/>
          </div>
          <div class="col-md-12 form-group text-right">
            <input v-if="!loading" type="submit" value="Cambiar" class="btn btn-primary"/>
            <button v-else class="btn btn-primary disabled" disabled>
              <font-awesome-icon icon="spinner" class="fa-spin"/> Enviando
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
import { KJUR, b64utoutf8 } from 'jsrsasign'

export default {
  data() {
    return {
      cambiarpass: false,
      email: '',
      password: '',
      error: '',
      passwordNew: '',
      passwordNew2: '',
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      logoOscuro: 'logoOscuro',
      perfilUsuario: 'perfilUsuario',
      credentials: 'credentials'
    })
  },
  mounted() {
    this.$store.dispatch("clearPolizas");
    this.$store.dispatch("clearSiniestros");
    this.$store.dispatch("clearProyectos");
  },
  methods: {
    login() {
      this.loading = true
      let url = this.urlBase + 'tokens';
      let options = {
          emulateJSON: true
      };
      let data = {
        'perfil_usuario': this.perfilUsuario,
        'email': this.email,
        'password': this.password
      };

      this.$http.post(url, data, options).then(
        response => {
          // Salvamos credenciales
          let tokenData = KJUR.jws.JWS.readSafeJSONString(b64utoutf8(response.body.token.split(".")[1]));
          let credentials = {
            logged: tokenData.logged,
            id: tokenData.id,
            email: tokenData.email,
            nombre: tokenData.nombre,
            token: response.body.token,
            cambiarPass: tokenData.cambiarPass,
            perfilUsuario: tokenData.perfilUsuario,
            error: ''
          };
          
          this.$store.dispatch("setCredentials", credentials);

          this.loading = false

          this.cambiarpass = credentials.cambiarPass
          if (this.cambiarpass) {
            return
          }

          // Config
          this.$store.dispatch("loadParametros")

          // Avisos
          let payload = {
            params: {
              'sort': 'incidenciaCliente.fechaCreacion',
              'usuarioWebCliente': 1,
              'inverse': true,
              'page': 1,
              'limit': 100
            },
            callbackOk: (responses) => {
              this.loading = false
            }
          }
          this.$store.dispatch("loadAvisos", payload)

          if (!credentials.cambiarPass) {
            // Vamos a la pagina que toque
            this.$router.replace(this.$route.query.redirect || '/');
          }
        },

        error => {
          this.loading = false
          if (error.status === 401) {
              this.error = "Usuario y/o contraseña incorrectos";
          }
          if (error.status === 404) {
              this.error = "Usuario y/o contraseña incorrectos";
          }
        }
      );
    },
    changePass() {
      if (this.passwordNew != this.passwordNew2) {
        alert("Deben coincidir las dos contraseñas")
        return
      }
      if (this.passwordNew.length < 6) {
        alert("La contraseña debe tener al menos 6 caracteres")
        return
      }
      this.loading = true
      let url = this.urlBase + 'clientesasurnet/'+ this.credentials.id;
      let data = {
          password: this.passwordNew
      };
      let options = {};
        
      this.$http.put(url, data, options).then(
        (response) => {
          let payload = {
            cambiarPass: false 
          };
          this.$store.commit("setChangePass", payload);
          this.loading = false

          alert("Contraseña cambiada correctamente")

          // Config
          this.$store.dispatch("loadParametros")

          // Avisos
          let payload2 = {
            params: {
              'sort': 'incidenciaCliente.fechaCreacion',
              'usuarioWebCliente': 1,
              'inverse': true,
              'page': 1,
              'limit': 100
            }
          }
          this.$store.dispatch("loadAvisos", payload2)

          // Vamos a la pagina que toque
          this.$router.replace('/');
          //location.reload()
        },
        (error) => {
          this.loading = false
          alert("Error cambiando al contraseña: " + error.body)
        }
      );
            
    },
    getUserData() {
      let url = this.urlBase + 'clientes/' + this.credentials.id;
      this.$http.get(url).then(
        response => {
          
        },

        error => {
          if (error.status === 401) {
              router.push({name:'Login'});
          }
        }
      )
    }
  }
}
</script>

<style>
.loginbox img {
  max-height: 90px;
}
</style>

